import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Collapse } from "@mui/material";

import CustomDropDownToggle from "../../common/CustomDropDownToggle";

import "./style.css";

function Sidebar(props) {
    const { role } = JSON.parse(localStorage.getItem("admin-info"));
    const navigate = useNavigate();
    const location = useLocation();
    const [menu, setMenu] = useState([
        {
            label: "Users",
            path: "/users-panel/user",
            type: "both",
            role: [1, 3, 4],
        },
        {
            label: "Notification",
            path: "/notifications-panel/push-notification",
            type: "both",
            role: [1, 3],
        },
        {
            label: "Indi Programs",
            path: "/indi-programs-panel/programs",
            type: "both",
            role: [1, 3],
        },
        {
            label: "Indi Challenges",
            path: "/indi-challenges-panel/challenges",
            type: "both",
            role: [1, 3],
        },
        {
            label: "Email",
            path: "/email-panel/discharged-patients",
            type: "both",
            role: [1, 3],
        },
        {
            label: "Sandbox",
            path: "/sandbox-panel/prompt",
            type: "both",
            role: [1, 3],
        },
        {
            label: "Cron",
            path: "/cron-panel/prompt",
            type: "both",
            role: [1, 3],
        },
        // {
        //     label: "App Settings",
        //     path: "/app-settings",
        //     type: "both",
        //     role: [1, 3],
        // },

    ]);
    const [filteredMenu, setFilteredMenu] = useState([]);

    const handleItemCollapse = (index, bool = null) => {

        const newMenu = filteredMenu.map((item, i) => {
            if (i == index) {
                return { ...item, isOpen: bool != null ? bool : !item.isOpen };
            } else {
                return item;
            }

        });


        setFilteredMenu(newMenu);
    }

    const filterMenuByRole = (menu, role) =>
        menu.reduce((acc, item) => {
            if (item.subMenu) {
                const filteredSubMenu = item.subMenu.filter((subItem) => subItem.role.includes(role));
                if (filteredSubMenu.length > 0) {
                    acc.push({ ...item, subMenu: filteredSubMenu });
                }
            } else if (item.role.includes(role)) {
                acc.push(item);
            }
            return acc;
        }, []);

    useEffect(() => {
        let newMenu = filterMenuByRole(menu, role);

        let hasActiveLink;
        newMenu = newMenu.map((item, i) => {
            hasActiveLink = false;
            if (item?.subMenu) {
                item.subMenu.map((subItem) => {
                    if (typeof subItem.path === "object") {
                        if (subItem.path.includes(location.pathname)) {
                            hasActiveLink = true;
                        }
                    } else {
                        if (location.pathname.includes(subItem.path)) {
                            hasActiveLink = true;
                        }
                    }
                });
            }

            // if (item?.subMenu) {
            //     item.subMenu.map((subItem) => {
            //         if (location.pathname.includes(subItem.path)) {
            //             hasActiveLink = true;
            //         }
            //     });
            // }

            if (hasActiveLink) {
                return { ...item, isOpen: true };
            } else {
                return item;
            }

        });

        setFilteredMenu(newMenu);
    }, [role]);

    return (
        <div id="sidebar">
            <div id="sidebar-header">
                <Link id="sidebar-logo" to="/">
                    <img src="/assets/images/logo.png" alt="indi" className="logo" />
                </Link>
            </div>

            <div id="sidebar-menu">
                {filteredMenu?.map((item, index) => {
                    let isActiveLink = typeof item.path === "object" ? (item?.path.includes(location.pathname)) : (item.path == "/" ? location.pathname == "/" : location.pathname.includes(item.path));
                    return (
                        <div key={index} className="menu-item clickable">
                            {item?.subMenu && <CustomDropDownToggle isOpen={item?.isOpen || false} toggle={() => { handleItemCollapse(index); }} />}

                            <Link
                                to={item?.path || "#"}
                                className={`p ${!item?.subMenu && `with-hover-effect ${isActiveLink ? "whe-active" : ""}`}`}
                                onClick={() => {
                                    // !item?.subMenu && navigate(item?.path);
                                    handleItemCollapse(index);
                                }}
                            >
                                {item?.label}
                            </Link>

                            {item?.subMenu && (
                                <Collapse in={item?.isOpen || false} timeout="auto" unmountOnExit>
                                    <div className="sub-menu">
                                        {item?.subMenu.map((subItem, subIndex) => {
                                            let isActiveLink2 = typeof subItem.path === "object" ? subItem.path?.includes(location.pathname) : location.pathname.includes(subItem.path);
                                            return (
                                                <Link
                                                    to={typeof subItem.path === "object" ? subItem?.path?.[0] : (subItem?.path || "#")}
                                                    className={`p with-hover-effect ${isActiveLink2 ? "whe-active" : ""}`}
                                                    onClick={() => {
                                                        navigate(subItem?.path);
                                                    }}
                                                >
                                                    {subItem?.label}
                                                </Link>
                                            );
                                        })}
                                    </div>
                                </Collapse>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    Profile: state.Profile,
});

export default connect(mapStateToProps, {})(Sidebar);
